<template>
  <div class="header-wrapper" :class="{ 'fixed-header-wrapper': isFixed }">
    <ul v-if="isChinese === 'lang_CN'" class="top-menu-nav">
      <li class="nav-icon">
        <a href="/" class="to-index"></a>
      </li>
      <!-- <li class="nav-item"><a class="nav-item-a" href="/">首页</a></li> -->
    </ul>
  </div>
</template>

<script>
  // import {
  // 	checkEmployeeUserExist,
  // 	getNewUserMsg,
  // 	getUpgradeNotice
  // } from '@/page/common/api.js'
  // import cDialog from '@/components/cDialog'
  import Vue from 'vue'
  import { Dropdown, DropdownItem, DropdownMenu } from 'element-ui'
  Vue.use(Dropdown)
  Vue.use(DropdownItem)
  Vue.use(DropdownMenu)
  export default {
    name: 'CHeader',
    components: {},
    props: {
      isFixed: {
        default: false,
      },
    },
    data() {
      return {
        isChinese: 'lang_CN',
        isLogin: false,
        userCode: '', // 用户名
        isShowDialog: false,
        noticeObj: {},
        dialogTitle: '提示',
      }
    },
    mounted() {
      if (sessionStorage.getItem('isChinese')) {
        this.isChinese = sessionStorage.getItem('isChinese')
      }
      this.getUserMsgFun()
      this.checkUpgradeNotice()
    },
    methods: {
      changeLan(lang) {
        this.isChinese = lang
        sessionStorage.setItem('isChinese', lang)
      },
      // 设置用户信息cookie:招投标列表跳详情使用
      setCookie(name, value, days, urls) {
        let d = new Date()
        d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * days)
        document.cookie = name + '=' + value + '; expires=' + d.toGMTString() + '; path=' + urls
      },
      // 获取用户信息：用户名、角色
      getUserMsgFun() {
        let userNameStr = ''
        let userRoleStr = '1'

        document.cookie.split(';').map(item => {
          if (item.split('=')[0].trim() == 'userName') {
            userNameStr = item.split('=')[1]
          }
          if (item.split('=')[0].trim() == 'userRole') {
            userRoleStr = item.split('=')[1]
          }
        })
        // cookie没有值则请求用户信息数据
        if (userNameStr) {
          this.isLogin = true
          this.userCode = userNameStr
          this.$emit('getUserRole', {
            type: userRoleStr,
            userCode: this.userCode,
          })
        } else {
          // getNewUserMsg().then((res) => {
          // 	if (res.code == 0) {
          // 		// 新用户接口有值取新用户信息，否则再掉旧用户接口取旧用户信息
          // 		if (res.entity) {
          // 			res.entity.map(item => {
          // 				if (item.businessRoleCode == 'SUPPLIER') {
          // 					userRoleStr = '2'
          // 				}
          // 				userNameStr = item.userName
          // 			})
          // 		}
          // 		if (userNameStr) {
          // 			this.setCookie('userName', userNameStr, '1', '/')
          // 			this.setCookie('userRole', userRoleStr, '1', '/')
          // 			this.isLogin = true
          // 			this.userCode = userNameStr
          // 			this.$emit('getUserRole', {
          // 				type: userRoleStr,
          // 				userCode: this.userCode
          // 			})
          // 		}
          // 	}
          // })
        }
      },
      goUserCenter() {
        location.href = '/'
        // checkEmployeeUserExist({
        // 	userName: this.userCode
        // }).then((res) => {
        // 	if (res.entity == 1) { // 1: 平台      2: 旧平台
        // 		location.href = '/vip/home'
        // 	} else {
        // 		location.href = '/aircap/getAccountData.shtml'
        // 	}
        // })
      },
      // 升级提示
      checkUpgradeNotice() {
        // getUpgradeNotice().then(res => {
        // 	let oldPublishat = '' // 每次对比发布时间是否改变
        // 	if (window.localStorage && localStorage.getItem('upgradeNotice_publishat')) {
        // 		oldPublishat = localStorage.getItem('upgradeNotice_publishat');
        // 	}
        // 	if (res.entity.publishat != null && res.entity.publishat != '' && oldPublishat != res.entity
        // 		.publishat) {
        // 		this.noticeObj = res.entity
        // 		localStorage.setItem('upgradeNotice_publishat', this.noticeObj.publishat);
        // 		this.dialogTitle = res.entity.title
        // 		this.isShowDialog = true
        // 	}
        // })
      },
    },
  }
</script>
`

<style lang="scss">
  .has-child-menu {
    margin-top: 0 !important;

    a {
      color: #555 !important;

      &:hover {
        color: #fff !important;
      }
    }
  }

  .header-wrapper {
    height: 90px;
    line-height: 100px;
    width: 100%;
    margin: 0;
    background-color: #fff;

    &.fixed-header-wrapper {
      position: absolute;
      top: 0;
      z-index: 10;
      background: none;

      .top-menu-nav {
        .nav-icon {
          .to-index {
            background-image: url('./images/sfkjLogo.png');
          }
        }

        .nav-item {
          .nav-item-a {
            color: #fff;
          }
        }

        .nav-item:hover {
          &:after {
            border-bottom: 4px solid #fff;
          }
        }

        .nav-operations {
          .login-section {
            color: #fff;

            &:after {
              background-color: #fff;
            }
          }

          .username-section {
            color: #fff;
          }

          .i18-section {
            color: #fff;
          }
        }
      }
    }

    .top-menu-nav {
      &.english {
        width: 1300px;
      }

      width: 1200px;
      list-style-type: none;
      white-space: nowrap;
      overflow: hidden;
      margin: auto;
      margin-top: 0;
      margin-bottom: 0;
      padding: 0;
      display: flex;
      align-items: center;

      .nav-icon {
        width: 150px;
        line-height: 100px;
        text-align: center;
        cursor: pointer;
        margin-right: 30px;

        .to-index {
          display: block;
          width: 150px;
          height: 50px;
          background-repeat: no-repeat;
          background-image: url('./images/icon_nobanner.png');
        }
      }

      .nav-item {
        padding: 0 18px;
        transition: 0.2s all linear;

        .nav-item-a {
          color: #f1d6d6;
          font-size: 16px;

          &.order-search {
            position: relative;

            i.new-icon {
              position: absolute;
              right: 10px;
              top: -16px;
              width: 37px;
              height: 16px;
              background: url('./images/new.png');

              &.english {
                right: 60px;
              }
            }
          }
        }
      }

      .nav-item:hover {
        position: relative;

        &::after {
          content: '';
          position: absolute;
          top: 65px;
          left: 40%;
          width: 20%;
          height: 1px;
          margin-top: 16px;
          border-bottom: 4px solid blue;
          transition: 0.2s all linear;
        }
      }

      .nav-operations {
        flex-grow: 1;
        text-align: right;

        .login-section {
          color: #fcfcfc;
          font-size: 16px;
          margin-right: 7px;

          // &:after {
          //     content: '';
          //     height: 9px;
          //     width: 1px;
          //     background-color: #aaa;
          //     display: inline-block;
          //     margin-left: 7px;
          // }
          &.user {
            display: inline-block;
            background: blueviolet;
            width: 80px;
            height: 28px;
            line-height: 28px;
            border: none;
            border-radius: 14px;
            margin-top: 36px;
            font-size: 12px;
            color: #fff;
            text-align: center;
          }
        }

        .regist-section {
          color: #fff;
          font-size: 16px;
          padding: 6px 11px 8px;
          margin-right: 15px;
          background-color: aquamarine;
          border-radius: 18px;
        }

        .username-section {
          display: inline-block;
          width: 144px;
          color: #fcfcfc;
          font-size: 16px;
          margin: 0 15px -44px 0;
          font-weight: 600;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;

          &:hover {
            text-decoration: underline;
          }
        }

        .i18-section {
          cursor: pointer;
          color: #fcfcfc;
          font-size: 16px;
        }
      }
    }
  }

  .upgrade-dialog .el-dialog .el-dialog__header {
    padding-right: 70px;
  }
</style>
